/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styled from '@emotion/styled';
import { colors, fontFamilies } from '../baseStyle/Variables';
import ReactModal from 'react-modal';

interface ModalProps {
  children: React.ReactNode;
}

const ModalCentering = styled.div`
  display: flex;
  padding: 0;
  width: 100%;
`;

const ModalStyle = styled.div`
  background-color: ${colors.white};
  border-radius: 0.3rem;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
  overflow: hidden;
  position: relative;

  @media (min-width: 480px) {
    margin: 90px auto 48px;
    min-height: 810px;
    width: 425px;
  }
`;

// Used in LeaseAgreement and (soon) VirtualCard pages
export const ModalStyleV2 = styled(ReactModal)`
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: rgb(255, 255, 255);
  overflow: auto;
  border-radius: 1rem;
  outline: none;
  padding: 1.5rem;
  margin: 4rem auto;
  max-width: 360px;

  p {
    font-family: ${fontFamilies.interLight};
    font-size: 1rem;
    text-align: center;
    margin-bottom: 0.5rem;
  }
  h2 {
    font-family: ${fontFamilies.gilroyBold};
    text-align: center;
    color: ${colors.darkBlue};
    font-size: 24px;
    line-height: 28px;
    font-weight: 700;
    margin-bottom: 0.5rem;
  }

  .close-button-container {
    position: relative;
    text-align: right;
    margin-bottom: 2rem;
  }
  .close-button {
    appearance: none;
    background: none;
    border: 0 none;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
  }
  .secondary-link {
    font-family: ${fontFamilies.interSemiBold};
    color: ${colors.koalafiBlue};
    cursor: pointer;
    text-align: center;
    margin-top: 1rem;
  }
`;

const Modal: React.FC<ModalProps> = ({ children }) => {
  return (
    <ModalCentering>
      <ModalStyle>{children}</ModalStyle>
    </ModalCentering>
  );
};

export default Modal;
